<div
  class="absolute left-0 top-0 z-0 h-full w-full animate-scan bg-linear-to-b from-transparent via-background-primary/90 to-transparent"></div>

<div class="z-10 text-center text-lg text-text-tertiary"><ng-content /></div>
